(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-website-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-disclosure-locale]').forEach((disclosure) => {
    const toggle = disclosure.querySelector('[data-disclosure-toggle]');
    const list = disclosure.querySelector('[data-disclosure-list]');

    if (!toggle || !list) return;

    const closeList = () => {
      toggle.setAttribute('aria-expanded', 'false');
      list.hidden = true;
    };

    const openList = () => {
      toggle.setAttribute('aria-expanded', 'true');
      list.hidden = false;
    };

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      isOpen ? closeList() : openList();
    });

    document.addEventListener('click', (event) => {
      if (!disclosure.contains(event.target)) closeList();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeList();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
